import React from 'react';
import { connect } from 'react-redux';
import { TopFixedContainer } from '../TopFixContainer';
import { ChatTrigger } from '../Chat/ChatTrigger';
import { CallMeBackCircle } from '../CallMeBack/ButtonCallMeBackCircle';
import { BottomFixedContainer } from '../BottomFixedContainer.js';
import { ButtonCallMeBack } from '../CallMeBack/ButtonCallMeBack';

export const ChatCallContainerComponent = ({ 
    isCallMeVisible = true,
    callMeSubmitSuccessTrackName = '',
    callMeSubmitStartTrackName = '',
    shouldDisplayButtons,
    trackerChat = () => {}, trackerCallMeClick = () => {},
}) => {
    if (!shouldDisplayButtons) {
        return null;
    }
    return (
        <React.Fragment>
            <div className="d-block d-xl-none">
                <TopFixedContainer>
                    <ChatTrigger isMobile={true} tracker={trackerChat} />
                    {isCallMeVisible && <CallMeBackCircle
                        trackerCallMeClick={trackerCallMeClick}
                        callMeSubmitStartTrackName={callMeSubmitStartTrackName}
                        callMeSubmitSuccessTrackName={callMeSubmitSuccessTrackName}
                    />}
                </TopFixedContainer>
            </div>
            <div className="d-none d-xl-block">
                <BottomFixedContainer>
                    <ChatTrigger isMobile={false} tracker={trackerChat} />
                    {isCallMeVisible && <ButtonCallMeBack 
                        trackerCallMeClick={trackerCallMeClick} 
                        callMeSubmitStartTrackName={callMeSubmitStartTrackName}
                        callMeSubmitSuccessTrackName={callMeSubmitSuccessTrackName}
                    />}
                </BottomFixedContainer>
            </div>

        </React.Fragment>
    );
}

const mapStateToProps = state => ({ shouldDisplayButtons: state.globalFormFieldsReducer.shouldDisplayCallMeButtons });

export const ChatCallContainer = connect(mapStateToProps)(ChatCallContainerComponent);